export const adminNavigation = {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
    },

    {
      name: "Bookings",
      url: "/booking",
    },
    {
      name: "Warehouse",
      url: "/warehouse",
    },
    {
      name: "Devices",
      url: "/devices",
    },
    {
      name: "Servicing",
      url: "/fieldOfService",
    },
    {
      name: "Manage Users",
      url: "/manageUsers",
    },
    {
      name: "History",
      url: "/history",
    },
    {
      name: "Notifications",
      url: "/notifications",
    },
    {
      name: "Message Center",
      url: "/managecenter",
    },
    {
      name: "Tag Orders",
      url: "/TagOrders/view",
    },
    {
      name: "Settings",
      url: "/settings/view",
    },
    {
      name: "Help Centre",
      url: "/helpCentre",
    },
    {
      name: "Contact",
      url: "/contact",
    },
    {
      name: "Profile",
      url: "/profile/view",
    },
  ],
};
